import { createApp } from 'vue';
import { ProductTutorialVideosApplication } from './application';

export class ProductTutorialVideos {
    async init({ store, selector }) {
        const app = createApp(ProductTutorialVideosApplication);
        app.use(store);
        app.mount(selector);
    }
}